import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Spinner } from '@klaro7/ui';

import { useCall } from '../context/CallContext';
import { getAnswerByToken } from '../services/answer.service';

export function AnswerCallPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const { presentIncomingFromToken } = useCall();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let done = false;
    if (!token) return;
    getAnswerByToken(token)
      .then((info) => {
        if (done) return;
        presentIncomingFromToken(info);
        // CallOverlay (and thus IncomingCallModal) is mounted app-wide inside
        // BrowserRouter, so any route shows the modal. Send the user home.
        navigate('/', { replace: true });
      })
      .catch(() => {
        if (!done) setError('Chiamata non più disponibile.');
      });
    return () => {
      done = true;
    };
  }, [token, presentIncomingFromToken, navigate]);

  if (error) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
        <p className="text-neutral-600">{error}</p>
        <a href="/" className="text-brand-teal underline">
          Torna alla home
        </a>
      </div>
    );
  }

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <Spinner size="lg" />
    </div>
  );
}
